import React, {useEffect, useState} from 'react';
import {refreshView, showNotification, SimpleForm, translate} from 'react-admin';

import {Grid} from '../../components'
import {connect} from "react-redux";
import axiosInstance from "../../api/axios";
import {compose} from "redux";
import withStyles from '@material-ui/core/styles/withStyles';
import AdmissionFields from "./AdmissionFields";
import cloneDeep from 'lodash/cloneDeep';
import AdmissionFieldsGdtxHybrid from "./AdmissionFieldsGdtxHybrid";
import AdmissionFieldsThuong from "./AdmissionFieldsThuong";

const styles = {
    item: {
        "& > table ": {
            width: '95%',
        },
        "& > table td:nth-child(2)": {
            textAlign: 'right',
        },
        "& > table thead": {    // hide the header
            display: 'none',
        },
    },
    select: {
        marginTop: '20px',
    },
    button: {
        // marginTop: '-20px',
        marginLeft: '10px'
    },
}
let timeout = null;
export const AdmissionEdit = ({
                                  translate,
                                  classes,
                                  showToolbar = true,
                                  redirect = "list",
                                  noCancelButton,
                                  event,
                                  ...props
                              }) => {

    const [values, setValues] = useState({
        id: null,
        selectedElectiveIds: [],
        selectedPhysicalIds: [],
        selectedGraduationIds: [],
        selectedElectives: [],
        isRedirect: false,
        saveDisabled: false,
        isFistTimeCheck: true,
        ready: false
    });
    const [programServices, setProgramServices] = useState([])
    const [categories, setCategories] = useState([])
    const [schoolServices, setSchoolServices] = useState([])
    const [selectedElectives, setSelectedElectives] = useState([])
    const [selectedGraduations, setSelectedGraduations] = useState([])
    const [selectedPhysicals, setSelectedPhysicals] = useState([])
    const [allProgramServices, setAllProgramServices] = useState([])
    const [useCategory, setUseCategory] = useState(false)
    const [regisGraduation, setRegisGraduation] = useState(false)
    const [regisExemption, setRegisExemption] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState({});
    const [templateVersion, setTemplateVersion] = useState({});
    const [selectedJobs, setSelectedJobs] = useState([]);
    useEffect(() => {
        if (props.id && values.isFistTimeCheck) {
            getDetails();
        }
    }, [values.isFistTimeCheck]);

    function getDetails() {
        const url = `/api/admissions/` + props.id;
        axiosInstance.get(url).then(rs => {
            const {data} = rs;
            setSelectedElectives(data.selectedElectives)
            setSelectedGraduations(data.selectedGraduationSubjects)
            setSelectedPhysicals(data.selectedPhysicals)
            setSelectedJobs(data.selectedJobs)
            setCategories(data.categories)
            setUseCategory(data.useCategory)
            setRegisGraduation(data.regisGraduation)
            setRegisExemption(data.regisExemption)
            setTemplateVersion(data.templateVersion)
            const clone = cloneDeep(data)
            clone.isFistTimeCheck = false;
            clone.ready = true;

            if (clone.additionalServices && clone.additionalServices.length > 0) {
                const arr = clone.additionalServices.filter(p => p.type === 'PROGRAM')
                setAllProgramServices(arr)
                setProgramServices(arr.filter(p => !p.admissionSubjectId || (p.admissionSubjectId && clone.selectedElectives.findIndex(s => s.admissionSubjectId === p.admissionSubjectId) >= 0)
                    || (p.admissionSubjectId && clone.selectedGraduationSubjects.findIndex(s => s.admissionSubjectId === p.admissionSubjectId) >= 0)))
                setSchoolServices(clone.additionalServices.filter(p => p.type === 'SERVICE'))
            }

            const gifteds = clone.gifteds
            const sports = gifteds.filter(p => p.type === 'SPORT')
            if (!sports || sports.length === 0) {
                clone.sports = [{name: '', achievement: '', note: '', type: 'SPORT'}]
            } else {
                clone.sports = sports
            }
            const cultures = gifteds.filter(p => p.type === 'CULTURE')
            if (!cultures || cultures.length === 0) {
                clone.cultures = [{name: '', achievement: '', note: '', type: 'CULTURE'}]
            } else {
                clone.cultures = cultures
            }
            const teams = gifteds.filter(p => p.type === 'TEAM')
            if (!teams || teams.length === 0) {
                clone.team = {name: '', achievement: '', note: '', type: 'TEAM'}
            } else {
                clone.team = teams[0]
            }
            const otherGifteds = gifteds.filter(p => p.type === 'OTHER')
            if (!otherGifteds || otherGifteds.length === 0) {
                clone.otherGifted = {name: '', type: 'OTHER'}
            } else {
                clone.otherGifted = otherGifteds[0]
            }

            setValues({...clone, merged: clone});
        });
    }

    const handleChange = prop => e => {
        if (!e) {
            return
        }
        const value = e.target?.value ? e.target?.value : ''

        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            if (prop.includes('\.')) {
                const arr = prop.split('\.')
                setValues({...values, [arr[0]]: {...values[[arr[0]]], [arr[1]]: value}});
            } else {
                setValues({...values, [prop]: value});
            }
        }, 100);
    };

    const handleChangeArray = (prop, field, index) => e => {
        if (!e) {
            return
        }
        const value = e.target.value ? e.target.value : e.target.checked;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            const arr = [...values[prop]]
            arr[index] = {...arr[index], [field]: value}
            setValues({...values, [prop]: arr});
        }, 100);
    };

    function validate() {
        const isBlank = value => !`${value || ''}`.trim();
        if (!values.customerPhone && !values.fatherPhone && !values.motherPhone && !values.guardianPhone) {
            props.showNotification('Vui lòng nhập ít nhất 1 số điện thoại.', 'warning');
            return false;
        }
        if (templateVersion === 'GDTX' || templateVersion === 'GDTX_HYBRID') {
            if (isBlank(values.permanentAddressWard)) {
                props.showNotification('Vui lòng nhập phường (xã) (địa chỉ thường trú).', 'warning');
                return;
            }
            if (isBlank(values.permanentAddressCity)) {
                props.showNotification('Vui lòng nhập tỉnh (tp) (địa chỉ thường trú).', 'warning');
                return;
            }

            if (isBlank(values.temporaryAddressWard)) {
                props.showNotification('Vui lòng nhập phường (xã) (địa chỉ tạm trú).', 'warning');
                return;
            }
            if (isBlank(values.temporaryAddressCity)) {
                props.showNotification('Vui lòng nhập tỉnh (tp) (địa chỉ tạm trú).', 'warning');
                return;
            }

            if (templateVersion === 'GDTX_HYBRID') {
                const requiredFields = values.phanLuong
                    ? [
                        ['truongThi', 'Trường thi lớp 10'],
                        ['sbd', 'SBD'],
                        ['monVan', 'Môn Văn'],
                        ['monToan', 'Môn Toán'],
                        ['monAnh', 'Môn Anh'],
                        ['tongDiemThi', 'Tổng cộng'],
                        ['diemUuTien', 'Điểm ưu tiên'],
                        ['diemKhuyenKhich', 'Điểm khuyến khích'],
                        ['tongDiem', 'Tổng điểm'],
                    ]
                    : [
                        ['monToan', 'Môn Toán'],
                        ['monVan', 'Môn Văn'],
                        ['monGdcd', 'Môn GDCD'],
                        ['monLy', 'Môn Lý'],
                        ['monHoa', 'Môn Hoá'],
                        ['monSinh', 'Môn Sinh'],
                        ['monSu', 'Môn Sử'],
                        ['monDia', 'Môn Địa'],
                        ['tbcn', 'TBCN'],
                        ['hocLuc', 'Học lực'],
                        ['hanhKiem', 'Hạnh kiểm'],
                    ];
                for (const [field, label] of requiredFields) {
                    if (isBlank(values[field])) {
                        props.showNotification(`Vui lòng nhập ${label}.`, 'warning');
                        return;
                    }
                }
            }
        } else {
            if (templateVersion === 'THUONG') {
                const requireField = (field, label) => {
                    if (isBlank(values[field])) {
                        props.showNotification(`Vui lòng nhập ${label}.`, 'warning');
                        return false;
                    }
                    return true;
                }
                const validPhone = (field, label, required = false) => {
                    const value = values[field];
                    if (required && isBlank(value)) {
                        props.showNotification(`Vui lòng nhập ${label}.`, 'warning');
                        return false;
                    }
                    if (!isBlank(value) && !/^(\d{10})$/.test(value)) {
                        props.showNotification(`${label} không hợp lệ.`, 'warning');
                        return false;
                    }
                    return true;
                }
                const validIdentifier = (field, label, required = false) => {
                    const value = values[field];
                    if (required && isBlank(value)) {
                        props.showNotification(`Vui lòng nhập ${label}.`, 'warning');
                        return false;
                    }
                    if (!isBlank(value) && !/^(\d{12})$/.test(value)) {
                        props.showNotification(`${label} không hợp lệ.`, 'warning');
                        return false;
                    }
                    return true;
                }
                const validYob = (field, label, required = false) => {
                    const value = values[field];
                    if (required && isBlank(value)) {
                        props.showNotification(`Vui lòng nhập ${label}.`, 'warning');
                        return false;
                    }
                    if (!isBlank(value) && !/^(\d{4})$/.test(value)) {
                        props.showNotification(`${label} không hợp lệ.`, 'warning');
                        return false;
                    }
                    return true;
                }
                if (!requireField('noiSinhCity', 'Nơi sinh')) return;
                if (values.noiSinhCity === 'OTHER' && !requireField('noiSinhKhac', 'Nơi sinh khác')) return;
                if (!requireField('nation', 'Dân tộc')) return;
                if (!requireField('nationality', 'Quốc tịch')) return;
                if (!requireField('religion', 'Tôn giáo')) return;
                if (!validPhone('customerPhone', 'SĐT học sinh', true)) return;
                if (values.haveFatherInfo) {
                    if (!requireField('fatherName', 'Họ tên Cha')) return;
                    if (!validYob('fatherDob', 'Năm sinh Cha', true)) return;
                    if (!validPhone('fatherPhone', 'SĐT Cha')) return;
                    if (!values.noFatherIdentifierNumber && !validIdentifier('fatherIdentifierNumber', 'CCCD Cha', true)) return;
                    if (!requireField('fatherJob', 'Nghề nghiệp Cha')) return;
                }
                if (values.haveMotherInfo) {
                    if (!requireField('motherName', 'Họ tên Mẹ')) return;
                    if (!validYob('motherDob', 'Năm sinh Mẹ', true)) return;
                    if (!validPhone('motherPhone', 'SĐT Mẹ')) return;
                    if (!values.noMotherIdentifierNumber && !validIdentifier('motherIdentifierNumber', 'CCCD Mẹ', true)) return;
                    if (!requireField('motherJob', 'Nghề nghiệp Mẹ')) return;
                } else {
                    if (!requireField('guardianName', 'Họ tên người giám hộ')) return;
                    if (!requireField('guardianGender', 'Giới tính người giám hộ')) return;
                    if (!validYob('guardianDob', 'Năm sinh người giám hộ', true)) return;
                    if (!validPhone('guardianPhone', 'SĐT người giám hộ', true)) return;
                    if (!validIdentifier('guardianIdentifierNumber', 'CCCD người giám hộ', true)) return;
                    if (!requireField('guardianJob', 'Nghề nghiệp người giám hộ')) return;
                }
                if (values.canSwim === true) {
                    if (!requireField('swimCertificate', 'Chứng chỉ bơi')) return;
                    if (!requireField('swimPlaceOfCertificate', 'Nơi cấp chứng chỉ bơi')) return;
                    if (!requireField('swimDateOfCertificate', 'Ngày cấp chứng chỉ bơi')) return;
                }
                if (values.haveCultureGifted && (isBlank(values.cultures?.[0]?.name) || isBlank(values.cultures?.[0]?.achievement))) {
                    props.showNotification('Vui lòng nhập thông tin năng khiếu Văn hoá - Nghệ thuật.', 'warning');
                    return;
                }
                if (values.haveSportGifted && (isBlank(values.sports?.[0]?.name) || isBlank(values.sports?.[0]?.achievement))) {
                    props.showNotification('Vui lòng nhập thông tin năng khiếu Thể dục thể thao.', 'warning');
                    return;
                }
                if (values.haveTeamGifted && (isBlank(values.team?.name) || isBlank(values.team?.achievement))) {
                    props.showNotification('Vui lòng nhập thông tin Công tác Đoàn đội - Phong trào học sinh.', 'warning');
                    return;
                }
                if (values.haveOtherGifted && isBlank(values.otherGifted?.name)) {
                    props.showNotification('Vui lòng nhập năng khiếu khác.', 'warning');
                    return;
                }
            }
            if (values.otherInsurance) {
                if (values.otherInsurance != 'Không có' && !values.insuranceNumber) {
                    props.showNotification('Vui lòng nhập Số bảo hiểm.', 'warning');
                    return;
                }
            } else {
                props.showNotification('Vui lòng chọn bảo hiểm.', 'warning');
                return;
            }
        }
        // if (templateVersion !== 'GDTX') {
        //     if (values.canSwim) {
        //         if (values.canSwim == 'Có') {
        //             if (!values.swimCertificate || !values.swimDateOfCertificate || !values.swimPlaceOfCertificate) {
        //                 props.showNotification('Vui lòng nhập thông tin chứng chỉ bơi.', 'warning');
        //                 return;
        //             }
        //         }
        //     } else {
        //         props.showNotification('Vui lòng chọn Biết bơi.', 'warning');
        //         return;
        //     }
        // }

        for (let i = 0; i < selectedElectives.length; i++) {
            if (!selectedElectives[i].name) {
                props.showNotification('Vui lòng chọn môn tự chọn.', 'warning');
                return;
            }
        }
        for (let i = 0; i < selectedJobs.length; i++) {
            if (!selectedJobs[i].name) {
                props.showNotification('Vui lòng chọn môn nghề.', 'warning');
                return;
            }
        }
        for (let i = 0; i < selectedPhysicals.length; i++) {
            if (!selectedPhysicals[i].name) {
                props.showNotification('Vui lòng chọn môn giáo dục thể chất.', 'warning');
                return;
            }
        }
        if (regisGraduation) {
            for (let i = 0; i < selectedGraduations.length; i++) {
                if (!selectedGraduations[i].name) {
                    props.showNotification('Vui lòng chọn môn thi tốt nghiệp.', 'warning');
                    return;
                }
            }
        }
        return true;
    }

    function save() {
        if (!validate()) {
            return;
        }
        const data = Object.assign({}, values);
        setValues({
            ...values, isRedirect: true
        });
        if (data.otherInsurance == 'Không có') {
            data.insuranceNumber = ''
        }
        if (data.canSwim !== true) {
            data.swimCertificate = ''
            data.swimDateOfCertificate = ''
            data.swimPlaceOfCertificate = ''
        }
        data.additionalServices = [...programServices, ...schoolServices]
        data.selectedElectives = selectedElectives
        data.selectedJobs = selectedJobs
        data.selectedPhysicals = selectedPhysicals
        data.selectedGraduationSubjects = selectedGraduations
        const gifteds = []
        if (values.haveCultureGifted && values.cultures) {
            gifteds.push(...values.cultures)
        }
        if (values.haveSportGifted && values.sports) {
            gifteds.push(...values.sports)
        }
        if (values.haveTeamGifted && values.team) {
            gifteds.push(values.team)
        }
        if (values.haveOtherGifted && values.otherGifted) {
            gifteds.push(values.otherGifted)
        }
        data.gifteds = gifteds
        data.categoryId = selectedCategory?.id
        const url = `/api/admissions/` + props.id;
        axiosInstance.put(url, data).then(rs => {
            props.showNotification('Cập nhật thành công');
        }, err => {
            props.showNotification(err.message, 'warning');
        })
    }

    function onDirectChange(prop, val) {
        setValues(prev => ({ ...prev, [prop]: val }));
    }
    // function onDirectChange2(prop, val) {
    //     if (prop.includes('.')) {
    //         const [prefix, key] = prop.split('.');
    //         setValues(prev => ({
    //             ...prev,
    //             [prefix]: {
    //                 ...(prev[prefix] || {}),
    //                 [key]: val
    //             }
    //         }));
    //     } else {
    //         setValues(prev => ({ ...prev, [prop]: val }));
    //     }
    // }
    return (
        <SimpleForm
            toolbar={null}
            record={values}
        >
            <Grid container spacing={8} alignItems="flex-start" classes={classes}>
                {'GDTX_HYBRID' === templateVersion ?
                    <AdmissionFieldsGdtxHybrid onChange={handleChange}
                                     defaultValue={values}
                                     save={save}
                                     allProgramServices={allProgramServices}
                                     programServices={programServices}
                                     schoolServices={schoolServices}
                                     setProgramServices={setProgramServices}
                                     useCategory={useCategory}
                                     categories={categories}
                                     setSchoolServices={setSchoolServices}
                                     onDirectChange={onDirectChange}
                                     handleChangeArray={handleChangeArray}
                                     selectedElectives={selectedElectives}
                                     setSelectedElectives={setSelectedElectives}
                                     selectedGraduations={selectedGraduations}
                                     setSelectedGraduations={setSelectedGraduations}
                                     selectedPhysicals={selectedPhysicals}
                                     setSelectedPhysicals={setSelectedPhysicals}
                                     selectedCategory={selectedCategory}
                                     setSelectedCategory={setSelectedCategory}
                                     regisExemption={regisExemption}
                                     regisGraduation={regisGraduation}
                                     templateVersion={templateVersion}
                                     selectedJobs={selectedJobs}
                                     setSelectedJobs={setSelectedJobs}
                    />
                    :
                    <>
                        {'THUONG' === templateVersion ?
                            <AdmissionFieldsThuong onChange={handleChange}
                                             defaultValue={values}
                                             save={save}
                                             allProgramServices={allProgramServices}
                                             programServices={programServices}
                                             schoolServices={schoolServices}
                                             setProgramServices={setProgramServices}
                                             useCategory={useCategory}
                                             categories={categories}
                                             setSchoolServices={setSchoolServices}
                                             onDirectChange={onDirectChange}
                                             handleChangeArray={handleChangeArray}
                                             selectedElectives={selectedElectives}
                                             setSelectedElectives={setSelectedElectives}
                                             selectedGraduations={selectedGraduations}
                                             setSelectedGraduations={setSelectedGraduations}
                                             selectedPhysicals={selectedPhysicals}
                                             setSelectedPhysicals={setSelectedPhysicals}
                                             selectedCategory={selectedCategory}
                                             setSelectedCategory={setSelectedCategory}
                                             regisExemption={regisExemption}
                                             regisGraduation={regisGraduation}
                                             templateVersion={templateVersion}
                                             selectedJobs={selectedJobs}
                                             setSelectedJobs={setSelectedJobs}
                            />
                            :
                            <AdmissionFields onChange={handleChange}
                                             defaultValue={values}
                                             save={save}
                                             allProgramServices={allProgramServices}
                                             programServices={programServices}
                                             schoolServices={schoolServices}
                                             setProgramServices={setProgramServices}
                                             useCategory={useCategory}
                                             categories={categories}
                                             setSchoolServices={setSchoolServices}
                                             onDirectChange={onDirectChange}
                                             handleChangeArray={handleChangeArray}
                                             selectedElectives={selectedElectives}
                                             setSelectedElectives={setSelectedElectives}
                                             selectedGraduations={selectedGraduations}
                                             setSelectedGraduations={setSelectedGraduations}
                                             selectedPhysicals={selectedPhysicals}
                                             setSelectedPhysicals={setSelectedPhysicals}
                                             selectedCategory={selectedCategory}
                                             setSelectedCategory={setSelectedCategory}
                                             regisExemption={regisExemption}
                                             regisGraduation={regisGraduation}
                                             templateVersion={templateVersion}
                                             selectedJobs={selectedJobs}
                                             setSelectedJobs={setSelectedJobs}
                            />
                        }
                    </>

                }




            </Grid>
        </SimpleForm>
    )
}

export default compose(
    connect(undefined, {refreshView, showNotification}),
    translate,
    withStyles(styles)
)(AdmissionEdit)
